import { Directive, ElementRef, Input, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Directive({
  selector: '[ivOptionTile]'
})
export class OptionTileDirective implements OnInit {

  @Input() animatedImage = '';

  @Input() timeoutDuration = 2000;

  staticImage;
  imgElement;
  isAnimating = false;

  constructor(private el: ElementRef, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.imgElement = this.el.nativeElement.getElementsByClassName('tile-image')[0];
    this.staticImage = this.imgElement.src;
  }

  setAnimatedImage() {
    if (!this.isAnimating) {
      this.isAnimating = true;
      // Sanitize animatedImage before setting src
      const safeAnimatedImage: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(this.animatedImage);
      this.imgElement.src = safeAnimatedImage as string;
      setTimeout(() => {
        // Sanitize staticImage before setting src
        const safeStaticImage: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(this.staticImage);
        this.imgElement.src = safeStaticImage as string;
        this.isAnimating = false;
      }, this.timeoutDuration);
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.setAnimatedImage();
  }

}
